<script setup lang="ts">
import { scrollToTop } from '@/utils/util'
defineProps<{
  activeClass: string
}>()
</script>

<template>
  <RouterLink
    to="/schedule"
    replace
    :aria-label="$t('schedule.title')"
    :active-class="activeClass"
    text-second
    flex
    flex-col
    items-center
    place-content-center
    h-full
    flex-1
    class="coarse-pointer:select-none"
    @click="scrollToTop">
    <div i-quill:calendar text-6.5 />
    <div text-xs mt-0.5>{{ $t('schedule.title') }}</div>
  </RouterLink>
</template>
